import React, { useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FlowScreenWrapper } from "../shared/FlowScreenWrapper";
import { useAuthContext } from "../../../AuthContextWrapper";
import { RadioAndResponseForm } from "../shared/RadioAndResponseForm";
import { Estate } from "../../../models/Estate";

export enum Outcomes {
  yes = "Yes",
  no = "No",
}

export const PassedYetScreen = (): JSX.Element => {
  const navigate = useNavigate();
  const { flow, activeEstate, setActiveEstate } = useAuthContext()
  const { screenName } = useParams();
  const currentScreen = flow?.getCurrentFlowScreen(screenName);

  const handleComplete = async (answer: string): Promise<boolean> => {
    if (!currentScreen) throw Error("couldn't determine currentScreen");

    const estate = activeEstate || new Estate();
    estate.hasPassed = answer === Outcomes.yes;

    try {
      await estate.saveEstate();
      setActiveEstate(estate);
    } catch (error) {
      throw new Error("could not save data");
    }

    flow?.navigateToNext(currentScreen, answer, navigate);
    return true;
  };

  let initAnswer = undefined;
  if (activeEstate?.hasPassed === true) {
    initAnswer = Outcomes.yes;
  } else if (activeEstate?.hasPassed === false) {
    initAnswer = Outcomes.no;
  }

  return currentScreen ? (
    <FlowScreenWrapper title="Has someone passed away yet?">
      <RadioAndResponseForm
        initAnswer={initAnswer}
        errorText="Oops! We need an answer to this question to continue."
        answerLabel="Passed yet"
        options={[
          { value: Outcomes.yes },
          {
            value: Outcomes.no,
            response:
              "It's smart to prepare for probate ahead of time. We’ll make sure you’re prepared to take action when the time comes.",
          },
        ]}
        onComplete={handleComplete}
      />
    </FlowScreenWrapper>
  ) : (
    <></>
  );
};
